module.exports = __webpack_public_path__ + "img/guanxilijie.243b794e.png";